'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import themeStyles from './theme.module.css';

export default function MissPlajaHeaderClient({ navItems }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);
  const toggleMenu = () => setIsMenuOpen((open) => !open);

  return (
    <header id="topnav" className={`defaultscroll sticky bg-white shadow-sm ${themeStyles.theme}`}>
      <div className="container">
        <Link className="logo" href="/" onClick={closeMenu}>
          <span className="logo-light-mode">
            <Image src="/images/miss-plaja/logo-miss-plaja.png" width={74} height={74} className="l-dark" alt="Miss Plaja" />
            <Image src="/images/miss-plaja/logo-miss-plaja.png" width={74} height={74} className="l-light" alt="Miss Plaja" />
          </span>
          <Image src="/images/miss-plaja/logo-miss-plaja.png" width={74} height={100} className="logo-dark-mode" alt="Miss Plaja" />
        </Link>

        <div className="menu-extras">
          <div className="menu-item">
            <button
              type="button"
              className={`navbar-toggle ${themeStyles.navToggleReset} ${isMenuOpen ? 'open' : ''}`}
              id="isToggle"
              aria-label={isMenuOpen ? 'Close navigation' : 'Open navigation'}
              aria-controls="navigation"
              aria-expanded={isMenuOpen}
              onClick={toggleMenu}
            >
              <div className="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>
          </div>
        </div>

        <div id="navigation" style={{ display: isMenuOpen ? 'block' : undefined }}>
          <ul className="navigation-menu nav-right">
            {navItems.map((item) => (
              <li key={item.href}>
                <Link href={item.href} onClick={closeMenu}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </header>
  );
}
